import { render, staticRenderFns } from "./SafetyEquipmentList.vue?vue&type=template&id=0623e21c&scoped=true&"
import script from "./SafetyEquipmentList.vue?vue&type=script&lang=js&"
export * from "./SafetyEquipmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623e21c",
  null
  
)

export default component.exports